import { baseInstance } from '@/apis';

const { post: basePost, get: baseGet } = baseInstance;

// 物流登录注册接口
// 登录接口
export function getLogin(params) {
  return basePost('/laoa-wuliu/api/login', params);
}
// 注册接口
export function getRegister(params) {
  return basePost('/laoa-wuliu/api/register', params);
}
// 发送验证码
export function getVerificationCode(params) {
  return basePost('/laoa-wuliu/api/sendVerificationCode', params);
}
// 发送图形验证码
export function getVerifyCode(params) {
  return baseGet('/laoa-wuliu/api/verifyCode', params);
}
// 忘记密码
export function getForgetPassword(params) {
  return basePost('/laoa-wuliu/api/forgetThePassword', params);
}

// 货主登录注册接口
// 登录接口
export function getHzLogin(params) {
  return basePost('/laoa-huozhu/api/login', params);
}
// 注册接口
export function getHzRegister(params) {
  return basePost('/laoa-huozhu/api/register', params);
}
// 发送验证码
export function getHzVerificationCode(params) {
  return basePost('/laoa-huozhu/api/sendVerificationCode', params);
}
// 发送图形验证码
export function getHzVerifyCode(params) {
  return baseGet('/laoa-huozhu/api/verifyCode', params);
}
// 忘记密码
export function getHzForgetPassword(params) {
  return basePost('/laoa-huozhu/api/forgetThePassword', params);
}

// 获取物流登录后用户的统计信息
export function getCompanyDataSta(params) {
  return basePost('/laoa-wuliu/api/wl/order/getCompanyDataSta', params);
}

// 获取货主登录后用户的统计信息
export function getHzCompanyDataSta(params) {
  return basePost('/laoa-huozhu/api/hz/order/getCompanyDataSta', params);
}

// 获取物流网站信息
export function getWuliuLogisticsInfo(params, config = {}) {
  return basePost('laoa-wuliu/qy/wuliu/ad/logistics/getLogisticsInfo', params, config);
}

// 获取货主网站信息
export function getHuozhuLogisticsInfo(params, config = {}) {
  return basePost('laoa-huozhu/api/common/getLogisticsInfoHuozhu', params, config);
}

// 获取分站信息
export function getSiteHostInfo(params) {
  return basePost('/laoa-advertisement/gw/company/getCompanyIdBySiteHost', params);
}

// 获取省市区分站信息
export function getQueryProvCity(params) {
  return basePost('/laoa-huozhu/api/hz/moduanCommunity/third/queryProvCity', params);
}
